if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.addEventListener('click', this.handleModelingClick.bind(this));

        // ZUCK-QA-FIX 2026-10-31: o ModalDialog do Dawn fecha num clique cujo alvo e
        // o proprio <quick-add-modal>. Na faixa do card o elemento tem um respiro
        // (padding) em volta da folha, entao um toque nessa borda -- ou o 2o toque
        // de um toque duplo na sacola, que agora fica sob a folha -- fechava a
        // faixa. Aqui, ancorada no card, esse clique e engolido (captura roda antes).
        this.addEventListener(
          'click',
          (event) => {
            if (event.target === this && this.anchorCard) {
              event.stopImmediatePropagation();
              event.preventDefault();
              return;
            }
            // ZUCK-QA-FIX 2026-10-31: clique-fantasma. A sacola fica embaixo do botao de
            // comprar da folha; o 2o clique de um clique duplo na sacola caia no botao e
            // ADICIONAVA AO CARRINHO sem a cliente ver a folha. Nos primeiros 450 ms
            // depois de abrir, um clique no botao de comprar e ignorado.
            if (
              this.anchorCard &&
              this.zqaShownAt &&
              performance.now() - this.zqaShownAt < 450 &&
              event.target.closest('.product-form__submit')
            ) {
              event.stopImmediatePropagation();
              event.preventDefault();
            }
          },
          true
        );
      }

      /**
       * ZUCK 2026-08-27 — a modelagem (`product-modeling-picker`) nao e uma opcao
       * de variante: sao <a href> para um PRODUTO irmao (Tradicional <-> Alca
       * Reta). Na PDP navegar e o comportamento certo; na faixa do card, nao —
       * trocar de modelagem tem que trocar o que vai pro carrinho sem sair da
       * pagina. Aqui o clique e interceptado e a faixa recarrega o irmao no lugar.
       * O href ja vem com `?variant=` da cor equivalente quando ela existe no
       * irmao, entao a cor escolhida sobrevive a troca.
       */
      handleModelingClick(event) {
        const link = event.target.closest('a.product-modeling-picker__option--link');
        if (!link || !this.modalContent || !this.modalContent.contains(link)) return;

        const url = link.getAttribute('href');
        if (!url) return;

        event.preventDefault();
        event.stopPropagation();
        this.swapModeling(url);
      }

      swapModeling(productUrl) {
        if (this.swappingModeling) return;
        this.swappingModeling = true;
        this.allowImageSync = true;
        this.zqaChosen = {}; // ZUCK-QA-BF
        this.modalContent.classList.add('quick-add-modal__content-info--loading');

        this.fetchProductElement(productUrl)
          .then((productElement) => {
            if (!productElement) return;
            this.injectProduct(productElement);
          })
          .finally(() => {
            this.swappingModeling = false;
            this.modalContent.classList.remove('quick-add-modal__content-info--loading');
          });
      }

      injectProduct(productElement) {
        this.preprocessHTML(productElement);
        HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
        this.runInjectedScripts(this.modalContent);
        this.initQuickAddGallery(this.modalContent);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.watchContent();
        this.armImageSyncOnInteraction();
        this.armKitSubmit();
        this.zqaArm(); // ZUCK-QA-BF
        this.zqaDecorate(); // ZUCK-QA-BF
        this.refreshBar();
        this.renderKitChrome();
      }

      armKitSubmit() {
        if (!this.modalContent || this.kitSubmitArmed) return;
        this.kitSubmitArmed = true;
        this.handleKitSubmitBound = this.handleKitSubmit.bind(this);
        // captura: precisa correr antes do <product-form> do tema, que senao
        // mandaria a peca sozinha para o carrinho como se fosse o produto todo.
        this.modalContent.addEventListener('click', this.handleKitSubmitBound, true);
      }

      /**
       * ZUCK 2026-08-28 — a foto do card acompanha a ESCOLHA do cliente, nunca a
       * abertura. Enquanto ninguem mexeu na faixa o sync fica desligado (era o que
       * fazia a foto piscar ao abrir); no primeiro `change` dentro da faixa —
       * trocar de cor, de tamanho — ele liga e a foto do card passa a seguir a
       * variante selecionada.
       */
      armImageSyncOnInteraction() {
        if (!this.modalContent || this.imageSyncArmed) return;
        this.imageSyncArmed = true;
        this.modalContent.addEventListener('change', () => {
          this.allowImageSync = true;
        });
      }

      /**
       * O tema re-renderiza o <product-info> a cada troca de variante
       * (`handleUpdateProductInfo` reescreve o `variant-selects`), o que apagaria
       * as setas do carrossel de cores. Em vez de tentar prever cada re-render,
       * um observer refaz o estado da faixa sempre que o conteudo muda.
       */
      watchContent() {
        if (this.contentObserver || !this.modalContent) return;
        this.contentObserver = new MutationObserver(() => {
          this.zqaDecorate(); // ZUCK-QA-BF: antes da pintura
          if (this.refreshQueued) return;
          this.refreshQueued = true;
          requestAnimationFrame(() => {
            this.refreshQueued = false;
            this.refreshBar();
          });
        });
        this.contentObserver.observe(this.modalContent, { childList: true, subtree: true });
      }

      /**
       * ZUCK 2026-08-28 — `syncCardImage()` NAO roda ao abrir. A foto do card so
       * muda quando a modelagem muda (que e o que foi pedido). Rodando na abertura
       * ela trocava a imagem do card pela `featured_image` da variante selecionada
       * — quase sempre um arquivo diferente — e o card piscava para outra foto
       * assim que a faixa aparecia.
       * Depois de uma troca de modelagem o sync continua ligado, para a foto
       * acompanhar tambem a cor escolhida dentro da faixa.
       */
      refreshBar() {
        this.zqaScheduleNeighbours(); // ZUCK-QA-BF
        this.ensureOptionScrollers();
        if (this.allowImageSync) this.syncCardImage();
        this.renderKitChrome();
      }

      // ---- carrossel horizontal das linhas de opcao -------------------------

      ensureOptionScrollers() {
        if (!this.modalContent) return;

        // a linha de modelagem tambem estoura em card estreito ("Tradicional" +
        // "Alca Reta" nao cabem em 178px), entao ela entra no mesmo tratamento.
        this.modalContent
          .querySelectorAll('fieldset.product-form__input, .product-modeling-picker__options')
          .forEach((row) => {
          const overflows = row.scrollWidth > row.clientWidth + 2;
          const existing =
            row.parentElement && row.parentElement.classList.contains('qa-scroller') ? row.parentElement : null;

          if (!overflows) {
            if (existing) existing.replaceWith(row);
            return;
          }
          if (existing) {
            this.updateScrollerState(existing, row);
            return;
          }

          const wrap = document.createElement('div');
          wrap.className = 'qa-scroller';
          row.parentNode.insertBefore(wrap, row);
          wrap.appendChild(row);

          ['prev', 'next'].forEach((dir) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'qa-scroller__nav qa-scroller__nav--' + dir;
            btn.setAttribute('aria-label', dir === 'prev' ? 'Ver cores anteriores' : 'Ver mais cores');
            btn.innerHTML =
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
              '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6" ' +
              'stroke-linecap="round" stroke-linejoin="round"/></svg>';
            btn.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              row.scrollBy({
                left: (dir === 'prev' ? -1 : 1) * Math.max(60, Math.round(row.clientWidth * 0.7)),
                behavior: 'smooth',
              });
            });
            wrap.appendChild(btn);
          });

          row.addEventListener('scroll', () => this.updateScrollerState(wrap, row), { passive: true });
          this.updateScrollerState(wrap, row);
        });
      }

      updateScrollerState(wrap, row) {
        const max = row.scrollWidth - row.clientWidth;
        wrap.classList.toggle('qa-scroller--at-start', row.scrollLeft <= 2);
        wrap.classList.toggle('qa-scroller--at-end', row.scrollLeft >= max - 2);
      }

      // ---- imagem do card acompanha a variante escolhida na faixa -----------

      /**
       * Trocar de modelagem (ou de cor) tem que trocar a foto do card. A variante
       * selecionada ja vem serializada no `script[data-selected-variant]` que o
       * variant-picker emite, e o `featured_image.src` dela e exatamente "a foto
       * da outra modelagem na cor atual" — nao precisa de request extra.
       * A foto original e guardada e restaurada ao fechar, porque o card continua
       * sendo o do produto original: titulo, preco e link nao mudam.
       */
      syncCardImage() {
        if (!this.anchorCard || !this.modalContent) return;

        const script = this.modalContent.querySelector('script[data-selected-variant]');
        if (!script) return;

        let src;
        try {
          src = JSON.parse(script.textContent)?.featured_image?.src;
        } catch (e) {
          return;
        }
        if (!src || src === this.appliedCardImage) return;

        const images = this.anchorCard.querySelectorAll('.card__media img');
        if (!images.length) return;

        const sep = src.includes('?') ? '&' : '?';
        const srcset = [165, 360, 533, 720, 940].map((w) => src + sep + 'width=' + w + ' ' + w + 'w').join(', ');
        images.forEach((img) => {
          // o original vai no proprio elemento: guardar referencias de nos deixava
          // a restauracao escrevendo em nos ja substituidos por um re-render, e a
          // foto trocada ficava presa no card.
          if (!img.hasAttribute('data-qa-original-src')) {
            img.setAttribute('data-qa-original-src', img.getAttribute('src') || '');
            img.setAttribute('data-qa-original-srcset', img.getAttribute('srcset') || '');
          }
          img.setAttribute('src', src + sep + 'width=533');
          img.setAttribute('srcset', srcset);
        });
        this.appliedCardImage = src;
      }

      /** Devolve QUALQUER foto trocada que tenha sobrado na pagina. */
      static restoreAllCardImages(scope) {
        (scope || document).querySelectorAll('img[data-qa-original-src]').forEach((img) => {
          const src = img.getAttribute('data-qa-original-src');
          const srcset = img.getAttribute('data-qa-original-srcset');
          if (src) img.setAttribute('src', src);
          else img.removeAttribute('src');
          if (srcset) img.setAttribute('srcset', srcset);
          else img.removeAttribute('srcset');
          img.removeAttribute('data-qa-original-src');
          img.removeAttribute('data-qa-original-srcset');
        });
      }

      restoreCardImage() {
        QuickAddModal.restoreAllCardImages(this.anchorCard);
        this.appliedCardImage = null;
        this.allowImageSync = false;
        this.imageSyncArmed = false;
        this.kit = null;
        this.kitPicks = [];
        this.kitStep = 0;
        this.kitBusy = false;
        this.kitSubmitArmed = false;
        this.zqaChosen = {}; // ZUCK-QA-BF
      }

      /**
       * ZUCK 2026-08-27 — ModalDialog.connectedCallback() move o elemento para o
       * <body>, o que serve a um modal de tela cheia mas impede ancorar o popover
       * ao card. Aqui ele fica onde foi renderizado, dentro do card.
       */
      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        const section = this.closest('.shopify-section');
        if (section) this.dataset.section = section.id.replace('shopify-section-', '');
      }

      /**
       * ZUCK 2026-08-28 — fechar ao interagir fora da faixa.
       * `pointerdown` e nao `click`: arrastar um carrossel de outra secao nunca
       * dispara `click`, entao a faixa ficava aberta enquanto a pagina se movia
       * embaixo dela. Em captura, para valer mesmo que o alvo pare a propagacao.
       * O proprio botao que abriu e ignorado — senao o pointerdown fecharia e o
       * click seguinte reabriria, piscando.
       */
      handleOutsideClick(event) {
        if (!this.hasAttribute('open') || this.closing) return;
        // ZUCK-QA-FIX 2026-10-31: fechar so num TOQUE fora. Antes o `pointerdown`
        // fechava no primeiro contato do dedo, entao comecar a rolar a pagina (ou
        // arrastar um carrossel) com o dedo fora da faixa a fechava "do nada".
        // Agora o pointerdown so marca; o fechamento vem no pointerup sem
        // arrasto. Rolar o card para fora da tela fecha pelo observer (zqaWatchVisibility).
        // ZUCK-QA-FIX2: tocar a sacola de outro card nao conta como "fora": o show()
        // daquele card fecha esta faixa de forma limpa (e pode ser o mesmo modal).
        if (event.target.closest('modal-opener')) return;
        if (event.type === 'pointerdown') {
          if (event.target.closest('quick-add-modal') === this) return;
          this.zqaDown = { x: event.clientX, y: event.clientY, t: Date.now() };
          return;
        }
        if (event.type === 'pointerup' || event.type === 'pointercancel') {
          const down = this.zqaDown;
          this.zqaDown = null;
          if (event.type === 'pointercancel' || !down) return;
          if (Math.abs(event.clientX - down.x) > 10 || Math.abs(event.clientY - down.y) > 10) return;
        }
        if (event.type === 'click') return;
        if (event.target.closest('quick-add-modal') === this) return;
        if (this.openedBy && event.target.closest('modal-opener') === this.openedBy.closest('modal-opener')) return;
        // `true` = nao devolver o foco ao botao que abriu: devolver dispara
        // `.focus()` nele e o navegador rola a pagina de volta para aquele card.
        this.hide(true);
      }

      /**
       * ZUCK 2026-08-27 — o ModalDialog fecha tirando o atributo `open`, o que faz a
       * faixa sumir num quadro. Aqui o fechamento roda a animacao de saida antes de
       * desmontar: `hide()` so marca e espera, `finishHide()` faz a limpeza real.
       * Tudo que desmonta (limpar innerHTML, restaurar a foto do card) fica no
       * finishHide, senao a faixa esvaziaria no meio da animacao.
       */
      hide(preventFocus = false) {
        // fora imediatamente: um segundo clique nao pode reentrar no fechamento
        document.removeEventListener('pointerdown', this.handleOutsideClick, true);
        document.removeEventListener('pointerup', this.handleOutsideClick, true); // ZUCK-QA-FIX
        document.removeEventListener('pointercancel', this.handleOutsideClick, true); // ZUCK-QA-FIX
        document.removeEventListener('click', this.handleOutsideClick, true);
        if (this.zqaVisibilityObserver) {
          this.zqaVisibilityObserver.disconnect();
          this.zqaVisibilityObserver = null;
        }
        if (this.closing) return;

        const panel = this.querySelector('.quick-add-modal__content');
        const reduceMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.hasAttribute('open') || !panel || reduceMotion) {
          this.finishHide(preventFocus);
          return;
        }

        this.closing = true;
        panel.classList.add('is-closing');

        let done = false;
        // ZUCK-QA-FIX2 2026-10-31: geracao do fechamento. Se a faixa reabrir (ou for
        // fechada na hora) antes do fim da animacao, este fechamento antigo nao roda:
        // era ele que, 200-400 ms depois, apagava a faixa recem-aberta.
        const zqaGen = (this.zqaCloseGen = (this.zqaCloseGen || 0) + 1);
        const finish = () => {
          if (done) return;
          done = true;
          if (zqaGen !== this.zqaCloseGen) return;
          panel.classList.remove('is-closing');
          this.closing = false;
          this.finishHide(preventFocus);
        };
        panel.addEventListener('animationend', finish, { once: true });
        // rede de seguranca: se a animacao nao disparar, nao deixa a faixa presa aberta
        setTimeout(finish, 400);
      }

      /** Fecha na hora, sem animacao e sem devolver o foco. */
      hideNow() {
        document.removeEventListener('pointerdown', this.handleOutsideClick, true);
        document.removeEventListener('pointerup', this.handleOutsideClick, true); // ZUCK-QA-FIX
        document.removeEventListener('pointercancel', this.handleOutsideClick, true); // ZUCK-QA-FIX
        document.removeEventListener('click', this.handleOutsideClick, true);
        if (this.zqaVisibilityObserver) {
          this.zqaVisibilityObserver.disconnect();
          this.zqaVisibilityObserver = null;
        }
        this.zqaCloseGen = (this.zqaCloseGen || 0) + 1; // ZUCK-QA-FIX2: invalida fechamento pendente
        if (this.closing) {
          this.closing = false;
          this.querySelector('.quick-add-modal__content')?.classList.remove('is-closing');
        }
        this.finishHide(true);
      }

      finishHide(preventFocus = false) {
        if (this.contentObserver) {
          this.contentObserver.disconnect();
          this.contentObserver = null;
        }
        this.restoreCardImage();
        if (this.anchorCard) this.anchorCard.classList.remove('has-quick-add-popover');
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        const modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        if (modalContent) modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      /**
       * ZUCK 2026-08-27 — Quick add simplificado.
       * O modal carrega o template `product.quick-add` (templates/product.quick-add.json)
       * em vez da PDP inteira: so titulo, preco, seletor de variante (cor/tamanho) e
       * adicionar ao carrinho. Se o template nao existir na loja, cai de volta na URL
       * normal do produto para nao quebrar o quick add.
       */
      static QUICK_ADD_VIEW = 'quick-add';

      /* ======================================================================
         ZUCK-QA-BF 2026-10-30 — velocidade + faixa do card (draft Black Friday)
         Velocidade:
         - `zqaFetchText`: uma resposta por URL em cache por 2 min (a promessa,
           entao abrir durante o pre-carregamento reaproveita a mesma requisicao).
           Depois da 1a resposta o id da secao do template quick-add fica guardado
           (sessionStorage, por tema) e as aberturas seguintes pedem so a secao.
         - Pre-carregamento na intencao: mouse parado no card (desktop), toque no
           botao da sacola, e cards parados na tela (orcamento por pagina).
         - Dentro da faixa: as respostas de "uma opcao de distancia" (outro
           tamanho, outra cor) sao pre-carregadas no ocioso e o product-info.js as
           usa (`window.ZuckQaPrefetch.take`) em vez de ir a rede.
         Faixa do card (so quando ancorada num card, `this.anchorCard`):
         - rotulos "Top" / "Calcinha" (sem "(Tamanho)");
         - nome da cor escolhida embaixo das bolinhas;
         - mobile: abre sem tamanho; o botao pede o tamanho e nada vai ao
           carrinho ate todos os tamanhos (top E calcinha) serem escolhidos.
         Nada aqui roda no quick add do carrinho nem no Compre junto.
         ====================================================================== */
      static zqaCache = new Map();
      static ZQA_TTL = 120000;

      static zqaSectionKey() {
        return 'zqaSection:' + ((window.Shopify && Shopify.theme && Shopify.theme.id) || '');
      }

      static zqaSectionId() {
        try {
          return sessionStorage.getItem(QuickAddModal.zqaSectionKey());
        } catch (e) {
          return null;
        }
      }

      static zqaForgetSection() {
        try {
          sessionStorage.removeItem(QuickAddModal.zqaSectionKey());
        } catch (e) {}
      }

      static zqaFetchText(baseUrl) {
        const sid = QuickAddModal.zqaSectionId();
        const url = sid && baseUrl.includes('?') ? baseUrl + '&section_id=' + encodeURIComponent(sid) : baseUrl;
        const hit = QuickAddModal.zqaCache.get(url);
        if (hit && Date.now() - hit.t < QuickAddModal.ZQA_TTL) return hit.p;
        const p = fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            if (!sid && /<product-info/.test(text)) {
              const m = text.match(/<product-info[^>]*\sid="MainProduct-[^"]*"[^>]*\sdata-section="([^"]+)"/) ||
                text.match(/<product-info[^>]*\sdata-section="([^"]+)"/);
              if (m) {
                try {
                  sessionStorage.setItem(QuickAddModal.zqaSectionKey(), m[1]);
                } catch (e) {}
              }
            }
            return text;
          });
        p.catch(() => QuickAddModal.zqaCache.delete(url));
        QuickAddModal.zqaCache.set(url, { t: Date.now(), p });
        return p;
      }

      static zqaPrefetchOpener(opener) {
        if (!opener || opener.closest('.has-quick-add-popover quick-add-modal')) return;
        if (window.ZuckQaPrefetch && window.ZuckQaPrefetch.paused()) return; // ZUCK-QA-FIX
        try {
          const proto = QuickAddModal.prototype;
          const kit = proto.readKitConfig.call(null, opener);
          const productUrl = kit ? kit.unitUrl : opener.getAttribute('data-product-url');
          if (!productUrl) return;
          const url = proto.buildQuickAddURL.call(null, productUrl, kit ? null : proto.selectedCardVariantId.call(null, opener));
          const p = QuickAddModal.zqaFetchText(url).catch(() => {});
          return p;
        } catch (e) {}
        return undefined;
      }

      /** ZUCK-QA-FIX: card rolado para (quase) fora da tela fecha a faixa */
      zqaWatchVisibility() {
        if (!this.anchorCard || !('IntersectionObserver' in window)) return;
        if (this.zqaVisibilityObserver) this.zqaVisibilityObserver.disconnect();
        this.zqaVisibilityObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[entries.length - 1];
            if (!entry.isIntersecting || entry.intersectionRatio < 0.25) this.hide(true);
          },
          { threshold: [0, 0.25] }
        );
        this.zqaVisibilityObserver.observe(this.anchorCard);
      }

      zqaIsCardSheet() {
        return Boolean(this.anchorCard && this.modalContent && this.modalContent.classList.contains('quick-add-modal__content-info--card'));
      }

      static zqaIsColourName(name) {
        const n = (name || '').toLowerCase();
        return /(^|[^a-z])(cor|cores|color|colour)([^a-z]|$)/.test(n) && n.indexOf('tamanho') === -1 && n.indexOf('size') === -1;
      }

      static zqaIsSingle(inputs) {
        return (
          inputs.length <= 1 ||
          inputs.every((i) => /^(u|único|unico|tamanho único|tamanho unico)$/i.test((i.value || '').trim()))
        );
      }

      /** grupos de radios por `name`, na ordem do DOM (a mesma do getter do Dawn) */
      zqaGroups(vs) {
        const groups = new Map();
        vs.querySelectorAll('fieldset input[type="radio"]').forEach((input) => {
          if (!groups.has(input.name)) groups.set(input.name, []);
          groups.get(input.name).push(input);
        });
        return groups;
      }

      zqaRequiredSizes(vs) {
        const out = [];
        this.zqaGroups(vs).forEach((inputs, name) => {
          const fs = inputs[0].closest('fieldset');
          if (!fs || !fs.classList.contains('product-form__input--pill')) return;
          if (QuickAddModal.zqaIsColourName(name) || QuickAddModal.zqaIsSingle(inputs)) return;
          out.push({ name, inputs, fieldset: fs });
        });
        return out;
      }

      zqaMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      zqaArm() {
        if (!this.modalContent || this.zqaArmedOn === this.modalContent) return;
        this.zqaArmedOn = this.modalContent;
        const info = this.modalContent;

        info.addEventListener(
          'change',
          (event) => {
            if (!this.zqaIsCardSheet()) return;
            const input = event.target;
            if (!input || input.type !== 'radio') return;
            const fs = input.closest('fieldset');
            if (fs && fs.classList.contains('product-form__input--pill')) {
              this.zqaChosen = this.zqaChosen || {};
              this.zqaChosen[input.name] = true;
            }
            // nome da cor: na hora, sem esperar a resposta do servidor
            if (fs && fs.classList.contains('product-form__input--swatch')) {
              const label = info.querySelector('.zqa-colour-name');
              if (label) label.textContent = input.value;
            }
            this.zqaDecorate();
          },
          true
        );

        // tamanho faltando: o botao nao envia; os tamanhos pendentes piscam
        const block = (event) => {
          if (!this.zqaIsCardSheet() || this.kit) return;
          const btn = event.type === 'submit' ? info.querySelector('.product-form__submit') : event.target.closest('.product-form__submit');
          if (!btn || !btn.classList.contains('zqa-needs-size')) return;
          event.preventDefault();
          event.stopPropagation();
          const vs = info.querySelector('variant-selects');
          if (!vs) return;
          this.zqaRequiredSizes(vs).forEach(({ name, fieldset }) => {
            if (this.zqaChosen && this.zqaChosen[name]) return;
            fieldset.classList.remove('zqa-nudge');
            void fieldset.offsetWidth;
            fieldset.classList.add('zqa-nudge');
            setTimeout(() => fieldset.classList.remove('zqa-nudge'), 900);
          });
        };
        info.addEventListener('click', block, true);
        info.addEventListener('submit', block, true);

        // intencao numa opcao da faixa: pre-carrega aquela resposta primeiro
        const intent = (event) => {
          if (!this.zqaIsCardSheet()) return;
          const label = event.target.closest && event.target.closest('variant-selects label');
          if (!label) return;
          const input = label.htmlFor ? info.querySelector('#' + CSS.escape(label.htmlFor)) : null;
          if (input) this.zqaPrefetchNeighbours([input]);
        };
        info.addEventListener('pointerover', intent, { passive: true });
        info.addEventListener('pointerdown', intent, { passive: true });
      }

      zqaDecorate() {
        if (!this.zqaIsCardSheet()) return;
        const info = this.modalContent;
        const vs = info.querySelector('variant-selects');
        if (!vs) return;

        // 4. rotulos "Top" / "Calcinha"
        vs.querySelectorAll('.product-form__input--pill legend, .product-form__input--pill .form__label').forEach((legend) => {
          const walker = document.createTreeWalker(legend, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            if (/\(\s*tamanhos?\s*\)/i.test(node.nodeValue)) {
              node.nodeValue = node.nodeValue.replace(/\s*\(\s*tamanhos?\s*\)\s*/gi, ' ').replace(/\s+$/, '');
            }
          }
        });

        // 2. nome da cor escolhida, ACIMA das bolinhas (rotulo da linha de cor; altura fixa: nada pula)
        const colourInputs = Array.from(vs.querySelectorAll('.product-form__input--swatch input[type="radio"]'));
        if (colourInputs.length) {
          const fs = colourInputs[0].closest('fieldset');
          let label = vs.querySelector('.zqa-colour-name');
          if (!label && fs) {
            label = document.createElement('p');
            label.className = 'zqa-colour-name';
            label.setAttribute('aria-live', 'polite');
            const anchor = fs.parentElement && fs.parentElement.classList.contains('qa-scroller') ? fs.parentElement : fs;
            anchor.before(label); // Nicolas 2026-10-31: acima, nao abaixo
          }
          // a linha de cor sobe com `order: -1` (component-product-variant-picker.css,
          // .product-form__input--color-first) quando nao esta embrulhada no carrossel;
          // o rotulo copia a ordem de quem esta logo depois dele, senao fica para tras.
          if (label && fs) {
            const row = fs.parentElement && fs.parentElement.classList.contains('qa-scroller') ? fs.parentElement : fs;
            if (label.nextElementSibling !== row) row.before(label);
            const order = getComputedStyle(row).order;
            if (label.style.order !== order) label.style.order = order;
          }
          const checked = colourInputs.find((i) => i.checked);
          const text = checked ? checked.value : '';
          if (label && label.textContent !== text) label.textContent = text;
        }

        // 3. mobile: sem tamanho ate a cliente escolher
        const btn = info.querySelector('.product-form__submit');
        const labelSpan = btn && btn.querySelector('span:not(.zuck-buy-pill__price)');
        let missing = [];
        if (this.zqaMobile() && !this.kit) {
          this.zqaChosen = this.zqaChosen || {};
          missing = this.zqaRequiredSizes(vs).filter(({ name }) => !this.zqaChosen[name]);
          missing.forEach(({ inputs }) =>
            inputs.forEach((input) => {
              if (input.checked) input.checked = false;
            })
          );
        }
        if (!btn || !labelSpan) return;
        if (missing.length) {
          const text = missing.length > 1 ? 'Selecione os tamanhos' : 'Selecione o tamanho';
          if (!btn.classList.contains('zqa-needs-size')) {
            btn.classList.add('zqa-needs-size');
            btn.setAttribute('data-zqa-label', labelSpan.textContent);
            btn.setAttribute('aria-disabled', 'true');
          }
          if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
          if (labelSpan.textContent !== text) labelSpan.textContent = text;
        } else if (btn.classList.contains('zqa-needs-size')) {
          btn.classList.remove('zqa-needs-size');
          btn.removeAttribute('aria-disabled');
          const original = btn.getAttribute('data-zqa-label');
          btn.removeAttribute('data-zqa-label');
          if (original != null && labelSpan.textContent !== original) labelSpan.textContent = original;
        }
      }

      zqaScheduleNeighbours() {
        if (!this.zqaIsCardSheet()) return;
        clearTimeout(this.zqaNeighbourTimer);
        this.zqaNeighbourTimer = setTimeout(() => {
          const run = () => this.zqaPrefetchNeighbours();
          if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 800 });
          else run();
        }, 150);
      }

      /** pre-carrega as respostas de "uma opcao de distancia" (ou so `only`) */
      zqaPrefetchNeighbours(only) {
        if (!this.zqaIsCardSheet() || !window.ZuckQaPrefetch) return;
        const info = this.modalContent;
        const pi = info.querySelector('product-info');
        const vs = pi && pi.querySelector('variant-selects');
        if (!pi || !vs) return;
        const sectionId = pi.dataset.originalSection || pi.dataset.section;
        const base = pi.dataset.url;
        if (!sectionId || !base) return;
        const groups = this.zqaGroups(vs);
        const names = Array.from(groups.keys());
        const build = (target) => {
          const values = [];
          names.forEach((name) => {
            const pick = name === target.name ? target : groups.get(name).find((i) => i.checked);
            if (pick && pick.dataset.optionValueId) values.push(pick.dataset.optionValueId);
          });
          const params = ['section_id=' + sectionId];
          if (values.length) params.push('option_values=' + values.join(','));
          return (target.dataset.productUrl || base) + '?' + params.join('&');
        };
        let candidates = only;
        if (!candidates) {
          const sizes = [];
          const colours = [];
          groups.forEach((inputs, name) => {
            inputs.forEach((input) => {
              if (input.checked || input.disabled) return;
              const label = input.id ? info.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
              if (label && label.offsetParent === null) return; // cor escondida (VIP/esgotada)
              (QuickAddModal.zqaIsColourName(name) || input.closest('.product-form__input--swatch') ? colours : sizes).push(input);
            });
          });
          // alterna tamanho e cor: as duas trocas ficam rapidas desde o inicio
          candidates = [];
          for (let i = 0; i < Math.max(sizes.length, colours.length); i++) {
            if (sizes[i]) candidates.push(sizes[i]);
            if (colours[i]) candidates.push(colours[i]);
          }
          // ZUCK-QA-FIX: menos pedidos (cada um conta no limite da loja): no mobile so cores
          if (this.zqaMobile()) candidates = colours.slice();
          candidates = candidates.slice(0, this.zqaMobile() ? 4 : 10);
        }
        candidates.forEach((input) => window.ZuckQaPrefetch.prefetch(build(input), Boolean(only)));
      }

      buildQuickAddURL(productUrl, variantId) {
        try {
          const url = new URL(productUrl, window.location.origin);
          url.searchParams.set('view', QuickAddModal.QUICK_ADD_VIEW);
          if (variantId) url.searchParams.set('variant', variantId);
          return url.pathname + url.search;
        } catch (e) {
          return productUrl;
        }
      }

      /**
       * ZUCK 2026-08-28 — modo kit.
       * Um kit nao e uma variante: a pagina do kit monta N pecas do produto
       * unitario e manda N linhas (`items[][id]`) para o carrinho. Adicionar a
       * variante do proprio kit daria UMA linha com as pecas todas iguais, e
       * qualquer regra presa ao produto unitario (brinde, bump) deixaria de ver
       * as pecas. Entao a faixa monta as pecas uma a uma, igual a pagina.
       * O card so entra nesse modo se souber as duas coisas — quantas pecas e
       * qual o produto unitario; sem isso segue como card normal.
       */
      readKitConfig(opener) {
        const card = opener.closest('[data-kit-units][data-kit-unit-url]');
        if (!card) return null;
        const units = parseInt(card.getAttribute('data-kit-units') || '0', 10);
        const unitUrl = card.getAttribute('data-kit-unit-url');
        if (!(units > 1) || !unitUrl) return null;
        return { units, unitUrl };
      }

      get isLastKitStep() {
        return !this.kit || this.kitStep >= this.kit.units - 1;
      }

      /** Cabecalho "PECA n DE N" + rotulo do botao, redesenhado a cada passo. */
      renderKitChrome() {
        if (!this.kit || !this.modalContent) return;

        const info = this.modalContent;
        let head = info.querySelector('.qa-kit-step');
        if (!head) {
          head = document.createElement('div');
          head.className = 'qa-kit-step';
          info.insertBefore(head, info.firstChild);
        }
        const dots = Array.from({ length: this.kit.units }, (_, i) =>
          '<span class="qa-kit-step__dot' + (i <= this.kitStep ? ' is-done' : '') + '"></span>'
        ).join('');
        head.innerHTML =
          '<span class="qa-kit-step__label">Peça ' + (this.kitStep + 1) + ' de ' + this.kit.units + '</span>' +
          '<span class="qa-kit-step__dots">' + dots + '</span>';

        const submit = info.querySelector('button[name=add]');
        if (submit) {
          const label = submit.querySelector('span') || submit;
          label.textContent = this.isLastKitStep ? 'Adicionar ao carrinho' : 'Próxima peça';
        }
      }

      /** Intercepta o botao: nos passos intermediarios ele avanca, nao adiciona. */
      handleKitSubmit(event) {
        if (!this.kit) return;
        const btn = event.target.closest('button[name=add]');
        if (!btn || !this.modalContent.contains(btn)) return;

        event.preventDefault();
        event.stopPropagation();
        if (this.kitBusy) return;

        const idInput = this.modalContent.querySelector('form [name="id"]');
        const variantId = idInput && idInput.value;
        if (!variantId || idInput.disabled) return;

        this.kitPicks[this.kitStep] = variantId;

        if (!this.isLastKitStep) {
          this.kitStep += 1;
          this.kitBusy = true;
          this.modalContent.classList.add('quick-add-modal__content-info--loading');
          this.fetchProductElement(this.kit.unitUrl)
            .then((productElement) => {
              if (productElement) this.injectProduct(productElement);
            })
            .finally(() => {
              this.kitBusy = false;
              this.modalContent.classList.remove('quick-add-modal__content-info--loading');
            });
          return;
        }

        this.addKitToCart(btn);
      }

      /** Manda as N pecas como N linhas, do mesmo jeito que a pagina do kit. */
      addKitToCart(button) {
        this.kitBusy = true;
        button.classList.add('loading');
        button.setAttribute('aria-disabled', 'true');
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const payload = {
          items: this.kitPicks.filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 })),
        };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showKitError(response.description || response.message);
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.setActiveElement && cart.setActiveElement(this.openedBy);
              this.hide(true);
              cart.renderContents(response);
            } else {
              this.hide(true);
            }
          })
          .catch(() => this.showKitError())
          .finally(() => {
            this.kitBusy = false;
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      showKitError(message) {
        const wrapper = this.modalContent.querySelector('.product-form__error-message-wrapper');
        const target = wrapper && wrapper.querySelector('.product-form__error-message');
        if (!wrapper || !target) return;
        target.textContent = message || 'Nao foi possivel adicionar o kit. Tente novamente.';
        wrapper.removeAttribute('hidden');
      }

      /**
       * ZUCK 2026-08-28 — a cor escolhida no card tem que valer na faixa.
       * O swatch ativo do card (`.card-product-swatch-btn.is-active`) carrega o
       * `data-variant-id`; abrindo a faixa com `?variant=` ela ja vem com aquela
       * cor marcada, em vez da variante padrao do produto.
       */
      selectedCardVariantId(opener) {
        const card = opener.closest('.product-card-wrapper') || opener.closest('.card-wrapper');
        const active = card && card.querySelector('.card-product-swatch-btn.is-active');
        return (active && active.getAttribute('data-variant-id')) || null;
      }

      fetchProductElement(productUrl, variantId) {
        const parse = (responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          return responseHTML.querySelector('product-info');
        };

        // ZUCK-QA-BF 2026-10-30: resposta em cache (pre-carregada na intencao) e,
        // depois da 1a abertura, so a secao (section_id) em vez da pagina inteira.
        // ZUCK-QA-FIX 2026-10-31: qualquer falha (429, secao errada, HTML sem
        // product-info) cai para a view quick-add inteira e depois para a PDP;
        // nenhuma resposta ruim fica em cache. Se tudo falhar, `show()` leva a
        // cliente para a pagina do produto em vez de nao fazer nada.
        const url = this.buildQuickAddURL(productUrl, variantId);
        const plain = (target) =>
          fetch(target)
            .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
            .then((responseText) => parse(responseText) || Promise.reject('no product-info'));
        return QuickAddModal.zqaFetchText(url)
          .then((responseText) => parse(responseText) || Promise.reject('no product-info'))
          .catch(() => {
            QuickAddModal.zqaForgetSection();
            return plain(url);
          })
          .catch(() => plain(productUrl))
          .catch(() => null);
      }

      show(opener) {
        // ZUCK-QA-FIX 2026-10-31: toque duplo no mesmo botao nao abre duas cargas
        if (this.zqaLoadingFor === opener) return;
        // ZUCK-QA-FIX2 2026-10-31: os cards de variante do MESMO produto dividem um so
        // <quick-add-modal> (#QuickAdd-<id do produto>). Abrir no card B com a faixa
        // aberta (ou fechando) no card A: termina A agora, sem animacao, antes de
        // ancorar em B. Sem isto o fechamento de A terminava depois e apagava B.
        if (this.hasAttribute('open') || this.closing) {
          if (this.hasAttribute('open') && !this.closing && this.openedBy === opener) return;
          this.hideNow();
        }
        // rede de seguranca: nenhuma foto trocada pode sobrar de uma sessao anterior
        QuickAddModal.restoreAllCardImages(document);

        // abrir a faixa de um card fecha a de qualquer outro — de imediato, sem
        // animacao: se a desmontagem da outra faixa acontecesse depois, o
        // `removeTrapFocus()` dela arrancaria o focus trap que esta acabou de
        // instalar, alem de mexer no foco (e no scroll) fora de hora.
        document.querySelectorAll('quick-add-modal[open]').forEach((other) => {
          if (other !== this && typeof other.hideNow === 'function') other.hideNow();
        });

        // ZUCK-QA-FIX2 2026-10-31: so a ULTIMA sacola tocada abre. Com toques rapidos
        // A -> B -> C a resposta de B chegava depois e abria B junto com C.
        QuickAddModal.zqaLatest = opener;
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        this.kit = this.readKitConfig(opener);
        this.kitPicks = [];
        this.kitStep = 0;
        this.zqaChosen = {}; // ZUCK-QA-BF: tamanhos escolhidos nesta abertura
        this.zqaLoadingFor = opener; // ZUCK-QA-FIX

        this.fetchProductElement(
          this.kit ? this.kit.unitUrl : opener.getAttribute('data-product-url'),
          this.kit ? null : this.selectedCardVariantId(opener)
        )
          .then((productElement) => {
            if (QuickAddModal.zqaLatest !== opener) return; // ZUCK-QA-FIX2: outra sacola foi tocada depois
            if (!productElement) {
              // ZUCK-QA-FIX 2026-10-31: nada carregou (ex.: 429) -> pagina do produto
              const link =
                opener.getAttribute('data-product-url') ||
                opener.closest('.card-wrapper')?.querySelector('a[href*="/products/"]')?.getAttribute('href');
              if (link) window.location.href = link;
              return;
            }

            this.anchorToCard(opener);
            this.injectProduct(productElement);
            // `overflow: clip` ja impede, mas se algum navegador cair para
            // `hidden` o foco na faixa rolaria o card e deslocaria a foto.
            if (this.anchorCard) {
              this.anchorCard.scrollTop = 0;
              this.anchorCard.scrollLeft = 0;
            }
            super.show(opener);
            this.zqaShownAt = performance.now(); // ZUCK-QA-FIX: guarda do clique-fantasma
            // super.show() trava o scroll do body — correto para um modal, errado
            // para um popover que vive dentro do card.
            document.body.classList.remove('overflow-hidden');
            if (this.anchorCard) {
              this.anchorCard.scrollTop = 0;
              this.anchorCard.scrollLeft = 0;
            }
            setTimeout(() => {
              document.addEventListener('pointerdown', this.handleOutsideClick, true);
              document.addEventListener('pointerup', this.handleOutsideClick, true); // ZUCK-QA-FIX
              document.addEventListener('pointercancel', this.handleOutsideClick, true); // ZUCK-QA-FIX
              this.zqaWatchVisibility(); // ZUCK-QA-FIX
            }, 0);
          })
          .finally(() => {
            this.zqaLoadingFor = null; // ZUCK-QA-FIX
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /**
       * Move o popover para dentro do card que o abriu, para que ele se posicione
       * em relacao ao card e nao a viewport.
       */
      anchorToCard(opener) {
        const card =
          opener.closest('.card__inner') || opener.closest('.card-wrapper') || opener.closest('.card');
        if (!card) return;
        if (this.parentElement !== card) card.appendChild(this);
        card.classList.add('has-quick-add-popover');
        this.anchorCard = card;
      }

      preprocessHTML(productElement) {
        // ZUCK 2026-08-27: a faixa tem paleta propria (fundo escuro translucido
        // sobre a foto), entao NAO copiamos `color-*`/`gradient` da secao — essas
        // classes pintavam a faixa de branco.
        this.modalContent.classList.add('quick-add-modal__content-info--card');
        this.preventDuplicatedIDs(productElement);
        this.stripLayoutClasses(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      /**
       * ZUCK 2026-08-27 — a faixa vive DENTRO da secao do card (o ModalDialog nao
       * move mais para o <body>), entao a markup injetada passa a receber as
       * regras de grid da secao hospedeira. Numa secao com 5 colunas isso deixava
       * o `.product__info-wrapper.grid__item` com 27px de largura dentro de um
       * card de 232px. Essas regras sao escopadas por `#shopify-section-...`,
       * ou seja, tem ID e nao da para vencer por especificidade — o certo e tirar
       * os ganchos: a faixa nao usa o grid do Dawn para nada.
       */
      stripLayoutClasses(productElement) {
        productElement.querySelectorAll('.grid, .grid__item, .page-width').forEach((el) => {
          el.classList.remove('grid', 'grid__item', 'page-width');
          Array.from(el.classList).forEach((name) => {
            if (name.startsWith('grid--')) el.classList.remove(name);
          });
        });
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      runInjectedScripts(container) {
        if (!container) return;

        container.querySelectorAll('script').forEach((oldScript) => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach((attr) => {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });
      }

      initQuickAddGallery(container) {
        if (!container) return;

        const galleryList = container.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        container.querySelectorAll('.slider-buttons').forEach((el) => {
          el.classList.remove('quick-add-hidden');
        });

        const getSelectedColor = () => {
          const checked = container.querySelector(
            'input[type="radio"][name*="Cor"]:checked, input[type="radio"][name*="Color"]:checked, input[type="radio"][name*="cor"]:checked'
          );
          if (checked) return checked.value.trim().toLowerCase();

          const selectedSwatch = container.querySelector(
            '.product-form__input--swatch input:checked + label, .swatch-input__input:checked + label'
          );
          if (selectedSwatch) {
            return (
              selectedSwatch.getAttribute('title') ||
              selectedSwatch.textContent ||
              ''
            )
              .trim()
              .toLowerCase();
          }

          const firstSlide = galleryList.querySelector('.product__media-item[data-media-group]');
          return (firstSlide?.dataset.mediaGroup || '').trim().toLowerCase();
        };

        const revealSlidesForSelectedColor = () => {
          const slides = [...galleryList.querySelectorAll('.product__media-item[data-media-group]')];
          if (!slides.length) return;

          const groups = slides
            .map((slide) => (slide.dataset.mediaGroup || '').trim().toLowerCase())
            .filter(Boolean);
          const selectedColor = getSelectedColor();
          const color =
            selectedColor && groups.includes(selectedColor) ? selectedColor : groups[0];

          let visibleCount = 0;
          slides.forEach((slide) => {
            const show = !color || (slide.dataset.mediaGroup || '').trim().toLowerCase() === color;
            slide.style.display = show ? 'block' : 'none';
            slide.classList.toggle('is-active', show && visibleCount === 0);
            if (show) visibleCount++;
          });

          const counterTotal = container.querySelector('.slider-counter--total');
          const counterCurrent = container.querySelector('.slider-counter--current');
          if (counterTotal) counterTotal.textContent = visibleCount;
          if (counterCurrent) counterCurrent.textContent = visibleCount > 0 ? '1' : '0';

          galleryList.scrollLeft = 0;
        };

        setTimeout(revealSlidesForSelectedColor, 150);
        setTimeout(revealSlidesForSelectedColor, 450);

        container.addEventListener(
          'change',
          (event) => {
            if (event.target.closest('variant-selects, .product-form__input, .swatch-input')) {
              setTimeout(revealSlidesForSelectedColor, 100);
            }
          },
          { passive: true }
        );
      }
    }
  );
}

/* ZUCK-QA-BF 2026-10-30 — pre-carregamento (draft Black Friday).
   `window.ZuckQaPrefetch`: respostas de troca de variante da faixa do card, em
   cache por URL exata (a mesma que o product-info.js monta). Fila com 2 em
   paralelo; `urgent` passa na frente (intencao do dedo/mouse). */
(function () {
  if (window.ZuckQaPrefetch) return;
  const TTL = 120000;
  const cache = new Map();
  const queue = [];
  let active = 0;
  const conn = navigator.connection || {};
  const frugal = Boolean(conn.saveData) || /(^|-)2g$/.test(conn.effectiveType || '');

  // ZUCK-QA-FIX 2026-10-31: a loja respondeu 429/erro -> pausa todo pre-carregamento por 60 s
  let pausedUntil = 0;
  const start = (url, entry) => {
    active++;
      entry.p = fetch(url)
        .then((response) => {
          if (!response.ok) {
            pausedUntil = Date.now() + 60000;
            return Promise.reject(response.status);
          }
          return response.text();
        })
        .finally(() => {
          active--;
          pump();
        });
      entry.p.catch(() => cache.delete(url));
  };
  const pump = () => {
    while (active < 2 && queue.length) {
      const url = queue.shift();
      const entry = cache.get(url);
      if (entry && !entry.p) start(url, entry);
    }
  };

  window.ZuckQaPrefetch = {
    hits: 0,
    paused() {
      return Date.now() < pausedUntil;
    },
    prefetch(url, urgent) {
      if ((frugal && !urgent) || Date.now() < pausedUntil) return;
      const hit = cache.get(url);
      if (hit && Date.now() - hit.t < TTL) {
        if (urgent && !hit.p) {
          // intencao do dedo/mouse: fura a fila e nao espera vaga
          const i = queue.indexOf(url);
          if (i !== -1) queue.splice(i, 1);
          start(url, hit);
        }
        return;
      }
      const entry = { t: Date.now(), p: null };
      cache.set(url, entry);
      if (urgent) start(url, entry);
      else {
        queue.push(url);
        pump();
      }
    },
    take(url) {
      const hit = cache.get(url);
      if (!hit || Date.now() - hit.t >= TTL) return null;
      if (!hit.p) {
        const i = queue.indexOf(url);
        if (i !== -1) queue.splice(i, 1);
        hit.p = fetch(url).then((response) => (response.ok ? response.text() : Promise.reject(response.status)));
        hit.p.catch(() => cache.delete(url));
      }
      this.hits++;
      // ZUCK-QA-FIX: pre-carregamento que falhou nunca vira resposta: busca de novo
      return hit.p.catch(() => fetch(url).then((response) => response.text()));
    },
  };

  const QA = customElements.get('quick-add-modal');
  if (!QA || !QA.zqaPrefetchOpener) return;
  const openerOf = (card) => card && card.querySelector('modal-opener .quick-add__submit[data-product-url]');

  // desktop: mouse parado ~90 ms no card
  let hoverTimer = null;
  let hoverCard = null;
  document.addEventListener(
    'pointerover',
    (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      const card = event.target.closest && event.target.closest('.card-wrapper');
      if (card === hoverCard) return;
      hoverCard = card;
      clearTimeout(hoverTimer);
      if (!card) return;
      hoverTimer = setTimeout(() => QA.zqaPrefetchOpener(openerOf(card)), 90);
    },
    { passive: true }
  );

  // trocou a cor no card: a faixa daquela cor ja comeca a vir (a sacola costuma ser o proximo toque)
  document.addEventListener('click', (event) => {
    const dot = event.target.closest && event.target.closest('.card-product-swatch-btn');
    if (!dot) return;
    setTimeout(() => QA.zqaPrefetchOpener(openerOf(dot.closest('.card-wrapper'))), 0);
  });

  // toque/clique no botao da sacola: na hora
  const pressed = (event) => {
    const btn = event.target.closest && event.target.closest('modal-opener .quick-add__submit[data-product-url]');
    if (btn) QA.zqaPrefetchOpener(btn);
  };
  document.addEventListener('pointerdown', pressed, { passive: true });
  document.addEventListener('touchstart', pressed, { passive: true });

  // card parado na tela: pre-carrega no ocioso, com orcamento por pagina
  if (frugal || !('IntersectionObserver' in window)) return;
  let budget = 4; // ZUCK-QA-FIX: era 6
  let chain = Promise.resolve();
  const timers = new WeakMap();
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const card = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          if (timers.has(card)) return;
          timers.set(
            card,
            setTimeout(() => {
              if (budget <= 0) return io.disconnect();
              if (window.ZuckQaPrefetch.paused()) return; // ZUCK-QA-FIX
              budget--;
              io.unobserve(card);
              // um por vez: a 1a resposta ensina o id da secao e as seguintes ja vem enxutas
              const go = () => {
                chain = chain.then(() => QA.zqaPrefetchOpener(openerOf(card), true));
              };
              if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 1500 });
              else go();
            }, 700)
          );
        } else if (timers.has(card)) {
          clearTimeout(timers.get(card));
          timers.delete(card);
        }
      });
    },
    { threshold: [0, 0.6] }
  );
  const observe = (root) =>
    (root || document).querySelectorAll('.card-wrapper').forEach((card) => {
      if (openerOf(card)) io.observe(card);
    });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => observe());
  else observe();
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
